/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import './App.scss';
import './index.css';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import NavigationSideBar from './layouts/navigationSideBar';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { isLoggedIn } from './modules/auth/services/auth.services';
import { useAuthentication } from './modules/auth/services/auth.provider';
import SpinnerProvider from './modules/shared/spinner.context';
import Dashboard from './modules/dashboard/pages/dashboard';
import Login from './modules/auth/pages/login';
import ContentCollection from './modules/content-collection/components/contentCollection';
import theme from './core/theme';
import { ThemeProvider } from '@mui/styles';
import ContentCreationDashboard from './modules/content-creation/contentCreationDashboard';
import ContentCollectionByBrand from './modules/tags/brands/components/contentCollectionByBrand';
import ContentCollectionByPerson from './modules/tags/persons/components/contentCollectionByPerson';
import ContentCollectionByIdentity from './modules/tags/identities/components/contentCollectionByIdentity';
import ContentCollectionByLocation from './modules/tags/locations/components/contentCollectionByLocation';
import ContentCollectionByEvent from './modules/tags/events/components/contentCollectionByEvent';
import ContentCollectionByAuthor from './modules/tags/authors/components/contentCollectionByAuthor';
import ContentCollectionByTheme from './modules/tags/theme/components/contentCollectionByTheme';
import ContentCreationPreFinalFiles from './modules/content-creation/components/partA/contentCreationPreFinalFiles';
import ContentCreationFinalFiles from './modules/content-creation/components/partB/contentCreationFinalFiles';
import ContentTypeAsset from './modules/asset-content-type/components/contentTypeAssets';
import ContentTypeAssetByVideo from './modules/asset-content-type/components/videos/contentTypeAssetByVideo';
import ContentTypeAssetByBook from './modules/asset-content-type/components/books/contentTypeAssetByBook';
import ContentTypeAssetByBlog from './modules/asset-content-type/components/blogs/contentTypeAssetByBlog';
import ContentTypeAssetByArticle from './modules/asset-content-type/components/articles/contentTypeAssetByArtcle';
import ContentTypeAssetByVlog from './modules/asset-content-type/components/vlogs/contentTypeAssetByVlog';
import ContentTypeAssetByQuote from './modules/asset-content-type/components/quotes/contentTypeAssetByQuote';
import ContentTypeAssetByPost from './modules/asset-content-type/components/posts/contentTypeAssetByPost';
import YouTubeMarketingFiles from './modules/content-marketing/components/youtube/youTubeMarketingFiles';
import SignUp from './modules/auth/pages/signUp';
import ResetPasswordModal from './modules/auth/pages/resetPassword';
import UnAuthorized from './modules/user/pages/unauthorized';
import ComplianceCheck from './modules/content-marketing/components/pages/ComplianceCheck';
import MediaLibrary from './modules/content-marketing/components/pages/MediaLibrary';
import PostComposer from './modules/content-marketing/components/pages/PostComposer';
import SEOExtension from './modules/content-marketing/components/pages/SEOExtension';
import Team from './modules/content-marketing/components/pages/Team';
import TimelineDemo from './modules/content-marketing/components/pages/TimelineDemo';
import TrendHub from './modules/content-marketing/components/pages/TrendHub';
import CMDashboard from './modules/content-marketing/components/pages/Dashboard';
import Analytics from './modules/content-marketing/components/pages/Analytics';
import Settings from './modules/content-marketing/components/pages/Settings';
import TopNavigation from './modules/content-marketing/components/components/TopNavigation';
import Calendar from './modules/content-marketing/components/pages/Calendar';
import EditProfile from './modules/user/components/editProfile';

function App() {
  const { currentUser, login, logout } = useAuthentication();

  /** Auto-restore login on mount */
  useEffect(() => {
    isLoggedIn().then(({ loggedIn, user }) => {
      if (loggedIn && user) login(user);
      else logout();
    });
  }, []);

  /* Layout for Content Marketing pages */
  const ContentMarketingLayout = () => (
    <div className="tw min-h-screen bg-[#F9FAFB]">
      <TopNavigation />
      <main className="w-full px-6 py-6">
        <Outlet />
      </main>
    </div>
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SpinnerProvider>
          <BrowserRouter>
            {!currentUser ? (
              <Routes>
                <Route path="*" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/reset-password/:token" element={<ResetPasswordModal />} />
              </Routes>
            ) : (
              <div className="flex h-screen overflow-hidden font-lato" style={{ marginLeft: '275px' }}>
                <NavigationSideBar />

                <div
                  className="flex-1 bg-[#F9FAFB]"
                  style={{
                    width: 'calc(100vw - 256px)',
                    overflowX: 'hidden',
                  }}
                >
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />

                    {/* Tags */}
                    <Route path="/theme" element={<ContentCollectionByTheme />} />
                    <Route path="/topic" element={<ContentCollectionByTheme />} />
                    <Route path="/sub-topic" element={<ContentCollectionByTheme />} />
                    <Route path="/brands" element={<ContentCollectionByBrand />} />
                    <Route path="/persons" element={<ContentCollectionByPerson />} />
                    <Route path="/identities" element={<ContentCollectionByIdentity />} />
                    <Route path="/locations" element={<ContentCollectionByLocation />} />
                    <Route path="/events" element={<ContentCollectionByEvent />} />
                    <Route path="/authors" element={<ContentCollectionByAuthor />} />

                    {/* Assets */}
                    <Route path="/asset-content-type" element={<ContentTypeAsset />} />
                    <Route path="/vlog" element={<ContentTypeAssetByVlog />} />
                    <Route path="/article" element={<ContentTypeAssetByArticle />} />
                    <Route path="/video" element={<ContentTypeAssetByVideo />} />
                    <Route path="/blog" element={<ContentTypeAssetByBlog />} />
                    <Route path="/quote" element={<ContentTypeAssetByQuote />} />
                    <Route path="/post" element={<ContentTypeAssetByPost />} />
                    <Route path="/book" element={<ContentTypeAssetByBook />} />

                    {/* Content */}
                    <Route path="/dashboard/content-collection" element={<ContentCollection />} />
                    <Route path="/dashboard/content-creation" element={<ContentCreationDashboard />} />
                    <Route
                      path="/dashboard/content-creation/pre-final-file"
                      element={<ContentCreationPreFinalFiles />}
                    />
                    <Route path="/dashboard/content-creation/final-file" element={<ContentCreationFinalFiles />} />

                    {/* Marketing */}
                    <Route path="/dashboard/content-marketing" element={<ContentMarketingLayout />}>
                      <Route index path="smDashboard" element={<CMDashboard />} />
                      <Route index element={<CMDashboard />} />
                      <Route path="compose" element={<PostComposer />} />
                      <Route path="calendar" element={<Calendar />} />
                      <Route path="trends" element={<TrendHub />} />
                      <Route path="media" element={<MediaLibrary />} />
                      <Route path="compliance" element={<ComplianceCheck />} />
                      <Route path="analytics" element={<Analytics />} />
                      <Route path="team" element={<Team />} />
                      <Route path="settings" element={<Settings />} />
                      <Route path="seo-extension" element={<SEOExtension />} />
                      <Route path="timeline-demo" element={<TimelineDemo />} />
                    </Route>

                    {/* Other */}
                    <Route path="/youtube" element={<YouTubeMarketingFiles />} />
                    <Route path="/facebook" element={<></>} />
                    <Route path="/instagram" element={<></>} />
                    <Route path="/linkedIn" element={<></>} />
                    <Route path="/twitter" element={<></>} />
                    <Route path="/unauthorized" element={<UnAuthorized />} />

                    <Route path="/edit-profile" element={<EditProfile />} />
                  </Routes>
                </div>
              </div>
            )}
          </BrowserRouter>
        </SpinnerProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
